import { render, staticRenderFns } from "./candidates.vue?vue&type=template&id=4e269cbc&scoped=true"
import script from "./candidates.vue?vue&type=script&lang=js"
export * from "./candidates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e269cbc",
  null
  
)

export default component.exports